<template>
  <main>
    <div class="row d-flex flex-row px-0 mx-0">
      <div class="col-12 px-0">
        <!-- Booker Results -->
        <template v-if="itemSelected == 1">
          <div class="col-12">
            <DashboardTeamLeader dashboardType="bdr" />
          </div>
        </template>

        <!-- BDR Tasks  -->
        <template v-if="itemSelected == 2">
          <BdrTasks />
        </template>

        <!-- Booker Overview  -->
        <template v-if="itemSelected == 3">
          <BookerOverview />
        </template>

        <!-- Booker Monthly Metrics  -->
        <template v-if="itemSelected == 4">
          <BookerMonthlyMetrics />
        </template>

        <!-- Booker Ranking  -->
        <template v-if="itemSelected == 5">
          <BookerRanking />
        </template>

        <!-- Booker Timing  -->
        <template v-if="itemSelected == 6">
          <BookerOverview type="timing" />
        </template>

        <!-- Booker Daily  -->
        <template v-if="itemSelected == 7">
          <BookerDaily />
        </template>

        <!-- Booker New Tasks  -->
        <template v-if="itemSelected == 8">
          <BdrNewTasks />
        </template>


        <!-- Booker Email Answers  -->
        <template v-if="itemSelected == 9">
          <BdrAnswerEmails />
        </template>

        <!-- Booker Payments  -->
        <template v-if="itemSelected == 10">
          <BookerPayments />
        </template>

        <!-- Booker Pipe  -->
        <template v-if="itemSelected == 11">
          <BookerPipe />
        </template>

         <!-- Booker Consistency  -->
         <template v-if="itemSelected == 12">
          <BookerConsistency type="consistency" />
        </template>

          <!-- Call statistics  -->
        <template v-if="itemSelected == 13">
          <BookerCallStatistics />
        </template>

        <!-- Booker Booker Allocation  -->
        <template v-if="itemSelected == 14">
          <BookerOrderDistribution />
        </template>

        <!-- Booker Phone  -->
        <template v-if="itemSelected == 15">
          <BookerPhone />
        </template>

        <!-- Booker Manager Pools  -->
        <template v-if="itemSelected == 16">
          <BookerManager />
        </template>

        <template v-if="itemSelected == 17">
          <BookerPipeStats />
        </template>

      </div>
    </div>
  </main>
</template>

<script>

import DashboardTeamLeader from "@/components/Dashboard/TeamLeaderDashboard.vue";
import BdrTasks from "@/components/BDR/BdrTasks.vue";
import BdrNewTasks from "@/components/BDR/BdrNewTasks.vue";
import BookerOverview from "@/components/BDR/BookerOverview.vue";
import BookerCallStatistics from "@/components/BDR/BookerCallStatistics.vue";
import BookerMonthlyMetrics from "@/components/BDR/BookerMonthlyMetrics.vue";
import BookerRanking from "@/components/BDR/BookerRanking.vue";
import BookerDaily from "@/components/BDR/BookerDaily.vue";
import BdrAnswerEmails from "@/components/BDR/BdrAnswerEmails.vue";
import BookerPayments from "@/components/BDR/BookerPayments.vue";
import BookerPipe from "@/components/BDR/BookerPipe.vue";
import BookerConsistency from "@/components/BDR/BookerConsistency.vue";
import BookerOrderDistribution from "@/components/BDR/BookerOrderDistribution.vue";
import BookerPhone from "@/components/BDR/BookerPhone.vue";
import BookerManager from "@/components/BDR/BookerManager.vue";
import BookerPipeStats from "@/components/BDR/BookerPipeStats.vue";

import { mapState } from "vuex";

export default {
  data() {
    return {
      total: null,
      completeLoading: true,
      tabs: {
        1: {
          id: 1,
          name: "Booker Results",
          total: null,
        },
        2: {
          id: 2,
          name: "Tasks",
          total: null,
        },
        3: {
          id: 3,
          name: "Booker Overview",
          total: null,
        },
        4: {
          id: 4,
          name: "Booker Monthly Metrics",
          total: null,
        },
        5: {
          id: 5,
          name: "Booker Ranking",
          total: null,
        },
        6: {
          id: 6,
          name: "Booker Timing",
          total: null,
        },
        7: {
          id: 7,
          name: "Booker Daily",
          total: null,
        },
        8: {
          id: 8,
          name: "New Tasks",
          total: null,
        },
        9: {
          id: 9,
          name: "Email Answers",
          total: null,
        },
        10: {
          id: 10,
          name: "Booker Payments",
          total: null,
        },
        11: {
          id: 11,
          name: "Booker Pipe",
          total: null,
        },
        12: {
          id: 12,
          name: "Booker Consistency",
          total: null,
        },
        13: {
          id: 13,
          name: "Call Statistics",
          total: null,
        },
        14: {
          id: 14,
          name: "Booker Allocation",
          total: null,
        },
        15: {
          id: 15,
          name: "Booker Phone",
          total: null,
        },
        16: {
          id: 16,
          name: "Manager Pools",
          total: null,
        },
        17: {
          id: 17,
          name: "Booker Stats",
          total: null,
        },
      },
      itemSelected: 1,
    };
  },
  components: {
    DashboardTeamLeader,
    BdrTasks,
    BookerOverview,
    BookerMonthlyMetrics,
    BookerRanking,
    BookerDaily,
    BdrNewTasks,
    BdrAnswerEmails,
    BookerPayments,
    BookerPipe,
    BookerConsistency,
    BookerCallStatistics,
    BookerOrderDistribution,
    BookerPhone,
    BookerManager,
    BookerPipeStats,
  },

  created() {
    if (typeof this.$route.params.item !== "undefined") {
      this.itemSelected = this.$route.params.item;
      if (this.isBdrUser && !['2', '5', '6', '11', '10','12', '16'].includes(this.itemSelected)) {
        console.log("no permitido: " + this.itemSelected)
        this.itemSelected = 2;
      }
      this.changeTab(this.itemSelected);
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
    isBdrUser() {
      return (this.user.team_role_id == 2 && this.user.role_id == 2)
    },
  },

  methods: {
    changeTab(index) {
      this.itemSelected = this.tabs[index].id;
      this.$emit("udpdateHeader", "allbdr", this.tabs[index].name )
      this.key++;
    },
  },
};
</script>
